import {css, injectGlobal} from '@emotion/css';
import { useNavigate } from '@solidjs/router';
import { Theme } from 'Shared/backend/Theme';
import { standardRules } from 'Shared/common/Sanitise';
import { haveVenueRole } from 'Shared/Page';
import {LoginBanner} from 'Shared/server/LoginBanner';
import { useSite, useUser } from 'Shared/SiteProvider';
import {AuthenticationForm, entryUrl, RegistrationForm, RegoEmailSent} from 'Shared/users/AuthenticationForm';
import { Match } from 'solid-js';
import { createSignal, Show, Switch } from 'solid-js';

export const loginStyle = () => css({
	background: 'white',
	minHeight: '100vh',
	maxWidth: 450,
	margin: '0 auto',
	padding: '2em',
	paddingTop: '1em',

	'.vosLogo': {
		display: 'block',
		width: '5em',
		margin: '0 auto'
	}
});


export default function LoginPage()
{
	const site = useSite();
	const user = useUser();
	const navigate = useNavigate();

	injectGlobal([standardRules,{body:Theme.body}]);

	const [regoEmail,setRegoEmail] = createSignal();

	/* If logged in go to the /admin or /manager page */
	const havePermission = site.type!='venue' || haveVenueRole(user,site);
	if (!user.isUnknown() && havePermission)
		navigate(entryUrl(site.type));

	return (
		<div class={loginStyle()}>
			<Switch>
				<Match when={!regoEmail()}>
					<LoginBanner />

					<AuthenticationForm />

					<Show when={useSite().type == 'artist'}>
						<RegistrationForm setRegoEmail={setRegoEmail} />
					</Show>
				</Match>
				<Match when={true}>
					<RegoEmailSent email={regoEmail()} />
				</Match>
			</Switch>
		</div>
	);
}

